import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const About = () => {
  const [aboutDoc, setAboutDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const snap = await getDoc(doc(db, "pages", "about"));
        setAboutDoc(snap.exists() ? snap.data() : null);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };
    fetchAbout();
  }, []);

  console.log("About page data:", { aboutDoc, loading, error });

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-text-light dark:text-text-dark mb-6">
        {aboutDoc?.title || "About"}
      </h1>
      <p className="text-lg text-neutral">{aboutDoc?.description || "No description available"}</p>
    </div>
  );
};

export default About;